import Entity from '../entity'

export default class Vendor extends Entity<number> {
    name: string = null;
    displayName: string = null;
    vendorNo: string = null;
    vendorImageUrl: string = null;
    bankCardNo: string = null;
    tenantId: number = null;
    identificationCardImageUrl: string = null;
    cooperationMode: string = null;
    isActive: boolean;
    remark: string = null;
    productionCount: number = 0;
    userName: string = null;
    creationTime: undefined;
    qrCode: '';
    locationName: '';
    address: '';
    latitude: '';
    longitude: '';
    coverImageUrl: '';
    storefrontPicUrl: '';
    tel: '';
    leafletImageUrl: '';
    leafletAniEnabled: false;
    leafletExpiredTime: '';
}